module.exports = __webpack_public_path__ + "static/img/notice-icon-2.c7b2c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/notice-icon-2.png
// module id = 2HEY
// module chunks = 85